<template>
  <div
      class="api-checker-container pa-0"
  >
    <v-row class="content-boxes mobile-row">
      <v-col
          class="mobile-col"
          cols="12"
          lg="7">
        <h2 class="ecl-u-type-heading-2 py-5">SHACL Validator</h2>
        <MainTabs/>
        <v-snackbar
            v-model="snackbar.show"
            :timeout="snackbar.timeout"
            :color="snackbar.color"
            multi-line
        >
          <div class="snackbar-message">
            {{ snackbar.text }}
          </div>
          <template v-slot:action="{ attrs }">
            <v-btn
                color="white"
                text
                v-bind="attrs"
                @click="snackbar.show = false"
            >
              Close
            </v-btn>
          </template>
        </v-snackbar>
        <router-view
            @validate-schema="validateSchema"
            @edit-in-editor="handleEditInEditor"
            @validate-in-editor="handleValidateInEditor"
            :editorModel="editorModel"
        />
      </v-col>
      <v-col
          class="mobile-col"
          cols="12"
          lg="5"
      >
        <Violations
            :violations="processedViolations"
            :violations-count="processedViolationsCount"
            :violations-success="violationsSuccess"
            :validation-source="validationSource"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>

import UrlTab from '@/components/UrlTab.vue';
import EditorTab from '@/components/EditorTab.vue';
import Violations from '@/components/Violations.vue';

import {mapGetters} from 'vuex';
import {readFileAsync} from '@/utils/helpers';
import MainTabs from "@/components/MainTabs";
// import { config as CONFIG } from '../../config/config';

export default {
  name: 'Main',

  components: {
    MainTabs,
    UrlTab,
    EditorTab,
    Violations,
  },

  metaInfo() {
    return {
      title: 'SHACL Validator - data.europa.eu',
      description: 'SHACL Validator - data.europa.eu',
    };
  },

  data: () => ({
    snackbar: {
      show: false,
      text: '',
      color: '',
      timeout: -1,
    },
    editorModel: {
      code: '',
      type: 'application/ld+json',
    },
    validationSource: null,
  }),

  computed: {
    ...mapGetters('violations', [
      'getViolations',
      'getViolationsSuccess',
      'getLoading',
      'getViolationsContext',
      'getShapeModel'
    ]),
    violations() {
      return this.getViolations;
    },
    violationContext() {
      return this.getViolationsContext;
    },
    processedViolations() {
      const cleanedViolations = [];
      if (this.violationContext) {
        const violationContextKey = Object.keys(this.violationContext) + ":";
        //console.log("violationContextKey:" + violationContextKey);
        //debugger
        this.violations.forEach(item => { // Add versions of properties with keys where the "sh:" prefix is stripped
          const cleanedItem = {};
          const keys = Object.keys(item);
          keys.forEach(key => {
            if (key.startsWith(violationContextKey)) {
              const strippedKey = key.substring(violationContextKey.length);
              const value = item[key];
              cleanedItem[strippedKey] = typeof value === "string" ? value : value['@id'];
            } else {
              cleanedItem[key] = item[key];
            }
          });
          cleanedViolations.push(cleanedItem);
        });
      }
      return cleanedViolations.filter((e) => e.resultSeverity);
    },
    processedViolationsCount() {
      return this.processedViolations.length;
    },
    violationsSuccess() {
      return this.getViolationsSuccess;
    },
    isLoading() {
      return this.getLoading;
    },
    violationsContext() {
      return this.getViolationsContext;
    }
  },

  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'snackbar/SHOW_MESSAGE') {
        const {text, color, timeout} = state.snackbar;
        this.snackbar.text = text;
        this.snackbar.color = color;
        this.snackbar.timeout = timeout;
        this.snackbar.show = true;
      }
    });
  },

  methods: {
    readFileAsync,
    /**
     * Validates API by schema
     */
    validateSchema(schema, type) {
      const shapeModel = this.getShapeModel
      this.$store.dispatch('violations/getViolationsBySchema', {schema, type, shapeModel});
      this.validationSource = 'editor';
    },
    async handleEditInEditor(schema, type) {
      await this.$router.replace({path: '/editor'});
      const code = typeof schema === 'string' ? schema : JSON.stringify(schema);
      this.editorModel = {type, code};
    },
    async handleValidateInEditor(schema, type) {
      await this.handleEditInEditor(schema, type);
      this.validateSchema(schema, type);
    },

    // Returns a filtered violations list referring to a whitelist of violation codes
    filterViolationsByCodes(violations, whitelist) {
      if (!violations) return null;

      // eslint-disable-next-line max-len
      let filteredViolations;

      if (whitelist) {
        filteredViolations = violations.filter((v) => {
          if (!v.rule_link) return false;

          const ruleUrl = new URL(v.rule_link);
          const ruleNumber = parseInt(ruleUrl.hash.substr(1), 10);
          return whitelist.includes(ruleNumber);
        });
      }

      return filteredViolations;
    },
    // Returns a transformed violations list to one violation type
    transformViolationsToType(violations, type) {
      if (!violations) return null;

      return violations.map((v) => ({...v, violation_type: type}));
    },
  },
};
</script>

<style lang="scss" scoped>
.content-boxes {
  padding: 0 40px;
  @media (max-width: 1263px) {
    padding: 0;
  }
}

.mobile-row {
  @media only screen and (max-width: 1263px) {
    max-width: 100%;
    margin: 0 !important;
  }
}

.mobile-col {
  @media only screen and (max-width: 1263px) {
    padding-left: 0;
    padding-right: 0;
  }
}

.snackbar-message {
  white-space: pre-line;
}
</style>
